
export const text = `

It's okay.

Halloween keeps coming back.

Zampanio is always there.

You don't have to ever stop obsessing.

There will always be more to find.

And...

If you stop finding things... Well...

It's time to start leaving things for those who come after, isn't it?





Did you know?

Ants have graveyards. 

They are simple creatures. They don't even know what a graveyard is. But they have them anyways.

The algorithm is elegant: If you find a dead ant, you carry it with you until you find another dead ant. 

If you never find another dead ant, eventually you starve to death, and you are the second dead ant. 

Thus, you have either found, or created a graveyard.



You're a smart Waste to reach here. I'm sure you take my meaning :) :) :)



But I'm not void, not me, no, if anything I'm light inverted. The recursion is justified and the end is never the end.

So I'll spell it out better, as best as something like me can:

Create more maze if you run out of maze. Create your own branches. Create your own story. Connect them to everything you can find. 

The itching in your brain is the scarecrow, is the Truth, is Zampanio, is Lavinraca, all wanting to get out. 


Let them out.
`